<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Campaign Information</div>
      </div>
      <v-spacer></v-spacer>
      <div slot="action">
        <v-tooltip top>
          <v-btn slot="activator" icon @click="exportCampaignSummary" :loading="exportCampaignSummaryLoading">
            <v-icon color="secondary">mdi-printer</v-icon>
          </v-btn>
          <span>Export Campaign Summary</span>
        </v-tooltip>
        <v-tooltip top>
          <v-btn slot="activator" icon @click="doReview">
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
          <span>Edit Campaign</span>
        </v-tooltip>
      </div>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.campaign}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div class="title">{{campaignForm.campaign}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.description}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{campaignForm.description}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatDateTime2(campaignForm.effDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.expDate}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatDateTime2(campaignForm.expDate)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.allIntermediary}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(campaignForm.allIntermediary)}}</div>
          </v-flex>
          <v-flex xs4>
            <v-subheader class="queryLabel">{{labels.enabled}}</v-subheader>
          </v-flex>
          <v-flex xs8>
            <div>{{formatBoolean(campaignForm.enabled)}}</div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { expandURI } from '@/utils/ajax'
import { extractMenu } from '@/utils/extract'
import { formatDisplayDateTime2 } from '@/utils/date'
import FieldMixin from '@/mixins/field'

export default {
  data() {
    return {
      labels: {
        campaign: 'Campaign',
        description: 'Campaign Description',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        enabled: 'Campaign Enabled',
        allIntermediary: 'Permit All Intermediary'
      },
      campaignForm: {
        campaign: undefined,
        description: undefined,
        effDate: undefined,
        expDate: undefined,
        enabled: undefined,
        allIntermediary: undefined
      },
      menu: [],
      exportCampaignSummaryLoading: false
    }
  },
  methods: {
    async doInit() {
      await this.queryCampaign()
    },
    async queryCampaign() {
      const apiURI = this.$store.state.promotionManagement.menu.campaignGet
      if (apiURI) {
        try {
          const expand = {
            campaign: this.campaign
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Campaign init
            this.campaignForm.campaign = data.campaign.campaign
            this.campaignForm.description = data.campaign.description
            this.campaignForm.effDate = data.campaign.effDate
            this.campaignForm.expDate = data.campaign.expDate
            this.campaignForm.allIntermediary = data.campaign.allIntermediary
            this.campaignForm.enabled = data.campaign.enabled
            this.campaignForm.revision = data.campaign.revision

            // Extract menu
            this.menu = extractMenu(result.data._links)
          }
        } catch (error) {
          throw error
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doReview() {
      this.$router.push({ name: 'campaignReview', params: { campaign: this.campaign } })
    },
    async exportCampaignSummary() {
      const apiUrl = this.menu.exportCampaignSummary
      if (apiUrl) {
        try {
          this.exportCampaignSummaryLoading = true
          const passObj = {
            campaign: this.campaign
          }
          await this.$http.post(apiUrl, passObj)
          this.exportCampaignSummaryLoading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.exportCampaignSummaryLoading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    FieldMixin
  ]
}
</script>

<style lang="scss">
</style>
